'use client';

import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import classNames from 'classnames';
import EntryItem, { TEntityItem } from './EntityItem';
import styles from './SurveySection.module.scss';
import '@splidejs/react-splide/css';
import ContactItem from './ContactItem';
import SliderArrow from './SliderArrow';

interface IEntitiesProps {
  entities: TEntityItem[];
  fullWidth?: boolean;
}

const EntitiesSlider = ({ entities, fullWidth }: IEntitiesProps) => (
  <Splide
    options={{
      pagination: false,
      autoWidth: true,
      gap: '24px',
      perMove: 1,
      ...(fullWidth ? { width: '100vw' } : { width: '55vw' }),
      padding: { right: 420 },
      breakpoints: {
        1919: {
          padding: { right: 320 },
        },
        1439: {
          padding: { right: 240 },
        },
        1279: {
          padding: { right: 72 },
          width: '100vw',
        },
        1023: {
          padding: { right: 64 },
          width: '100vw',
        },
        767: {
          padding: { right: 24 },
          width: '100vw',
        },
      },
    }}
    className={styles.slider}
    hasTrack={false}
  >
    <SplideTrack className={styles.sliderTrack}>
      {entities.map(item => (
        <SplideSlide key={item.id}>
          <EntryItem item={item} />
        </SplideSlide>
      ))}
      <SplideSlide>
        <ContactItem />
      </SplideSlide>
    </SplideTrack>
    <div className={classNames(styles.navigation, 'splide__arrows')}>
      <SliderArrow type='prev' />
      <SliderArrow type='next' />
    </div>
  </Splide>
);

export default EntitiesSlider;
